<template>
  <tk-container
    class=""
  >
    <div
      slot="header"
      class="p-15"
    >
      <global-back />
    </div>
    <div
      class="h-100vh text-15 px-15 pb-15"
    >
      <div
        class="flex cursor-pointer items-center justify-between border-gray-F1F4F8 border-solid py-22 border-b border-width-1"
        @click="$push({
          path: '/article/detail',
          query: { type: '1' },
        })"
      >
        <div>隐私政策</div>
        <van-icon name="arrow" color="#9C9C9C" />
      </div>
      <div
        class="flex cursor-pointer items-center justify-between border-gray-F1F4F8 border-solid py-22 border-b border-width-1"
        @click="$push({
          path: '/article/detail',
          query: { type: '0' },
        })"
      >
        <div>用户协议</div>
        <van-icon name="arrow" color="#9C9C9C" />
      </div>
    </div>
  </tk-container>
</template>

<script>
export default {
  name: 'article-protocol',
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
</style>
